import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
class DI3ds extends React.Component {
    componentDidMount(){
      this.formRef.current.submit();
    }
    constructor(props){
      super(props);
      this.configs=JSON.parse(this.props.cc3dsResponse);
      this.formRef=React.createRef();
    }
    
    insertInputs = (invdata)=> {
        const keys = Object.keys(this.configs);
        let inputs = [];
        for(let i=0;i<keys.length;++i){
          inputs.push(<input key={keys[i]} type="hidden" name={keys[i]} value={this.configs[keys[i]]}/>);
      }
        return inputs;
      }
      createForm = () => {
          let action = this.configs.dsAuthURL;
          return(
                  <Row>
                        <Col sm={12}>
                            <form ref={this.formRef} id="moodleform" target="myiframe" method="post" action={action}>
                                {this.insertInputs()}
                            </form>
                            <iframe id="myiframe" name="myiframe" width="100%" height={70/100*window.screen.height}  frameBorder="0"></iframe>
                        </Col>
                  </Row>
          );
      }
      render(){
        return this.createForm();
      }
}
export default DI3ds;